module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921004151_T.aa1436a1.jpg";